import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/bob/left_back.png";

function Challengebob() {
  return (
    <section
      className="challenge_bob p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <h2 style={{ fontWeight: "400", color: "#000" }}>
              <strong>
                The Challenge Involved in Creating A Modernized Business Listing
                Mobile Application
              </strong>
              Leveraging Our Expertise to Tackle Challenges
            </h2>
            <p>
              Tekrevol analyzed the client’s requirements and market conditions
              to streamline the process of developing the B.O.B mobile
              application. However, the app needed much more sophisticated
              functionality and an interactive customer experience to get
              businesses to believe in its viability and usage benefits.
            </p>
            <p>
              Therefore, we researched the competitiveness of the business
              directory market to analyze what needed to be done to attract the
              audience, increase satisfaction, integrate a seamless
              functionality, and boost the B.O.B’s user experience. In a
              nutshell, we wanted to create a one-stop mobile solution for all
              business needs. The business listing mobile application would
              enable the user to add business information, add location, see
              market trends, etc.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-0 text-center"
          >
            <div className="intro_img">
              <StaticImage
                src="../../../images/case-studies/bob/challenge_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={800}
                height={802}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengebob;
